import classNames from 'classnames';

import styles from './MonthlyStepper.module.scss';

import { MonthlyStepperFooterFooterProps } from './types';
import { numberFormat } from './utils';

const MonthlyStepperFooter = ({
  selectedSummaryTotals,
  slideDirection,
  enableAnimation = true,
}: /* selectedHeaderMonths, */
MonthlyStepperFooterFooterProps) => {
  return (
    <table>
      <tr
        className={classNames({
          [styles['calendar-slide']]: enableAnimation,
          [styles['slide-left']]: enableAnimation && slideDirection === 'left',
          [styles['slide-right']]: enableAnimation && slideDirection === 'right',
        })}
      >
        {selectedSummaryTotals.map((value) => {
          return (
            <td className={classNames('text-right')} key={value.monthIndex}>
              <span>
                {numberFormat(value.value)}
              </span>
            </td>
          );
        })}
      </tr>
    </table>
  );
};

export default MonthlyStepperFooter;
